import { RollbackOutlined, SaveOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Col, Input, message, Row } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  Back,
  DefaultErrorMessage,
  Save,
  UpdateDataSuccessfully,
} from "shared/constants/define-localization";
import {
  THEME_TEMPLATE_ROUTE,
  UPDATE_THEME_TEMPLATE_ROUTE,
} from "shared/constants/routes";
import { CoreResource, t } from "shared/plugins/localization";
import { setLoading } from "states/global-value/global-value.slice";
import {
  addThemeTemplate,
  getThemeTemplateById,
  updateThemeTemplate,
} from "states/theme-template/theme-template.api";
import {
  ThemeTemplateItem,
  ThemeTemplateModel,
  ThemeType,
} from "states/theme-template/theme-template.models";
import { ThemeTemplateGroup } from "./components/theme-template-group";

export interface IAddUpdateThemeTemplaateProps {}
type TParams = { id: string };

export function AddUpdateThemeTemplate(props: IAddUpdateThemeTemplaateProps) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<TParams>();
  const [model, setModel] = useState<ThemeTemplateModel>({
    value: {},
  } as ThemeTemplateModel);

  const _handleOnSave = async () => {
    if (
      !checkEmptyValue({
        name: model.name,
        type: ThemeType.Group,
        value: model.value,
      })
    ) {
      message.error("Vui lòng thêm phần tử vào nhóm");
      return;
    }
    dispatch(setLoading(true));
    try {
      if (id) {
        await updateThemeTemplate(model);
      } else {
        await addThemeTemplate(model);
      }
      message.success("Cập nhật thành công");
      history.go(0);
    } catch (error) {
      message.error(error?.response?.data?.error?.message);
    }
    dispatch(setLoading(false));
  };

  const checkEmptyValue = (template: ThemeTemplateItem) => {
    if (
      (template.type === ThemeType.Group ||
        template.type === ThemeType.GroupList) &&
      Object.entries(template.value).length === 0
    ) {
      return false;
    }
    for (let item in template.value) {
      const valid = checkEmptyValue(template.value[item]);
      if (!valid) return false;
    }
    return true;
  };

  const _handleGetUpdate = async () => {
    try {
      let response = await getThemeTemplateById(id);
      setModel(response.data);
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };

  useEffect(() => {
    if (document.location.href.indexOf(UPDATE_THEME_TEMPLATE_ROUTE) > 0) {
      _handleGetUpdate();
    }
    document.title = "Thêm theme template";
  }, []);

  return (
    <div className="add-update-theme-template">
      <Row gutter={[16, 16]} className="mb-4">
        <Col flex="auto">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={THEME_TEMPLATE_ROUTE}>Theme template</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Thêm theme template</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col flex="auto" className="d-flex justify-content-end">
          <Link to={THEME_TEMPLATE_ROUTE} className="mr-2">
            <Button type="default" icon={<RollbackOutlined />}>
              {"Quay lại"}
            </Button>
          </Link>
          <Button
            onClick={_handleOnSave}
            type="primary"
            icon={<SaveOutlined />}
          >
            {"Lưu"}
          </Button>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mb-4">
        <Col span={8}>
          <Input
            value={model.name}
            placeholder="Tên template"
            onChange={(ev) => {
              setModel({ ...model, name: ev.target.value });
            }}
          />
        </Col>
        <Col span={8}>
          <Input
            value={model.slug}
            placeholder="TEMPLATE_NAME KEY (*)"
            onChange={(ev) => {
              setModel({ ...model, slug: ev.target.value });
            }}
          />
        </Col>
      </Row>

      <ThemeTemplateGroup
        model={{ name: model.name, type: ThemeType.Group, value: model.value }}
        itemKey={model.slug}
        onChange={(changedModel) => {
          setModel({ ...model, value: changedModel.value });
        }}
      />
    </div>
  );
}
